module.exports = __webpack_public_path__ + "img/image_frame.5b69afc7.png";